import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  inject,
} from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import { CustomPreloadingStrategy } from './core/preloading-strategy.service';
import { TranslocoHttpLoader } from './core/transloco-loader';
import { AppAccessService } from './core/services/app-access.service';
import { PreferencesService } from './core/services/preferences.service';

import { routes } from './app.routes';
import { authErrorInterceptor } from './core/auth/auth-error.interceptor';
import { authInterceptor } from './core/auth/auth.interceptor';

function initializeAppAccess() {
  return () => {
    inject(AppAccessService);
    return Promise.resolve();
  };
}

function initializeLanguage() {
  return () => {
    const preferences = inject(PreferencesService);
    const transloco = inject(TranslocoService);
    transloco.setActiveLang(preferences.getLanguage());
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(CustomPreloadingStrategy)),
    provideHttpClient(withInterceptors([authInterceptor, authErrorInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['es', 'en', 'pt'],
        defaultLang: 'es',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        fallbackLang: 'es',
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppAccess,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeLanguage,
      multi: true,
    },
  ],
};
